import React from 'react';
import PropTypes from 'prop-types'

const Avatar = ({ initial }) => {
    return (
        <span className="_kanis_avatar_container">
            <span className="_kanis_avatar">{initial.toUpperCase()}</span>
        </span>
    )
}

Avatar.propTypes = {
    initial: PropTypes.string
}

export default Avatar;